import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Grid, TextField } from "@mui/material";
import BackButton from "../components/BackButton";
import { FaSearch } from "react-icons/fa";

export default function Header({
  onBack,
  title,
  searchText,
  setSearchText,
  extra,
  playbarSection,
  isSmallScreen = false,
}) {
  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={2}
      className="topSection"
      alignItems="stretch"
      sx={{ mt: 0, mb: 2 }}
    >
      <Grid item xs={3} md={1} className="center-item">
        {onBack && <BackButton onBack={onBack} />}
      </Grid>

      <Grid
        item
        xs={9}
        md={3}
        className="center-item"
        sx={{ justifyContent: "flex-start" }}
      >
        <Typography variant="h1" fontWeight={800} sx={{ fontSize: "32px" }}>
          {title}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        md={1}
        className="center-item"
        sx={{ justifyContent: "flex-start" }}
      >
        {extra && extra}
      </Grid>
      {!isSmallScreen && (
        <Grid item xs={12} md={3} className="center-item">
          {playbarSection && playbarSection}
        </Grid>
      )}

      <Grid item xs={12} md={3} className="center-item">
        <Box className="topSection-searchBar">
          <TextField
            size="small"
            fullWidth
            className="topSection-searchBarInput"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            disabled={!setSearchText}
            sx={{ backgroundColor: "white", borderRadius: "5px" }}
          />
          <Box className="topSection-searchBarIcon">
            <FaSearch />
          </Box>
        </Box>
      </Grid>
      {isSmallScreen && (
        <Grid item xs={12} md={3} className="center-item">
          {playbarSection && playbarSection}
        </Grid>
      )}
      <Grid item xs={12} md={1} className="center-item"></Grid>
    </Grid>
  );
}
